<template>
    <div id="secure">
        <!-- START NAV -->
        <TopMenu />
        <!-- END NAV -->
        <div class="container">
            <div class="columns">
                <div class="column is-12">
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a v-on:click="goHome()">Super Admin</a>
                            </li>
                            <li>
                                <a v-on:click="goSuperItems()">Items</a>
                            </li>
                            <li class="is-active">
                                <a href="#" aria-current="page">View Template</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            
            <div class="columns">
                <div class="column is-12">
                    <div class="card is-hidden1">
                        <div class="card-header">
                            <p class="card-header-title">View Template</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns" style="margin-top: -50px;">
                <div class="column is-4">
                    <input class="input is-success" type="text" placeholder="Template Name" v-model="templateData.name">
                </div>
                <div class="column is-8">
                    <multiselect v-model="templateData.selectedItems" :options="listItem" :close-on-select="false" :multiple="true" :hide-selected="true" label="name" track-by="_id" placeholder="Items under this template"></multiselect>
                </div>
            </div>
            <div class="columns">
                <div class="column is-8"><button class='button is-primary  is-fullwidth' v-on:click="updateTemplate()" >Update Template</button></div>
                <div class="column is-4"><button class='button is-danger  is-fullwidth' v-on:click="removeTemplate()" >Remove Template</button></div>
            </div>
            <loading :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="true">
            </loading>
        </div>
    </div>
</template>

<script>
import TopMenu from "./TopMenu";
import axios from "axios";
import Loading from "vue-loading-overlay";
import Multiselect from 'vue-multiselect'
import "vue-loading-overlay/dist/vue-loading.css";
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: "SuperTemplateView",
    components: {
        TopMenu,
        Loading,
        Multiselect
    },
    data() {
        return {
            superId: "",
            superEmail: "",
            _id: "",
            templateData: [],
            isLoading: false,
            listItem: [],
        };
    },
    created() {
        this.superId = localStorage.getItem("superId");
        this.superEmail = localStorage.getItem("superEmail");

        
        this._id = this.$store.getters.getSuperViewTemplateID;
        if (this._id.trim.length < 1){
            this._id = localStorage.getItem('SUPER_VIEW_TEMPLATE_ID')
        }

        console.log("90 this._id: " + this._id)

        this.getTemplateData()
        this.getItems()
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        removeTemplate(){
            this.$swal({
                title: "Confirm?",
                text: "Are you sure you want to remove this template?",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                if (result.value){ 
                    axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
                    axios.defaults.responseType = "json";
                    axios.post(process.env.MY_URL + "/super/template/remove", {
                        superEmail: localStorage.getItem("superEmail"),
                        _id: this.templateData._id
                    })
                    .then(response => {
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                            this.goSuperItems()
                        }
                    })
                    .catch(e => {
                        console.log(e.response);
                        if (e.response.status == 400) {
                            Toast.open({
                                message: e.response.data.msg,
                                type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            });
                        } else {
                            Toast.open({
                                message:
                                    "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                                type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            });
                        }
                    });
                }
            })
        },
        getTemplateData(){
            let self = this;
            self.listItem = []
            self.isLoading = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/template/view", {
                    superEmail: localStorage.getItem("superEmail"),
                    _id: this._id
            })
            .then(response => {
                if (response.data.success == true) {
                    self.templateData = response.data.template
                } else {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading = false;
            })
            .catch(e => {
                console.log(e.response);
                if (e.response.status == 400) {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                } else {
                    Toast.open({
                        message:
                            "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading = false;
            });
        },
        updateTemplate(){
            let self = this;
            var name = self.templateData.name;
            var selectedItems = self.templateData.selectedItems;

            if ((!name) || (name.length < 1)){
                Toast.open({
                    message: "Please enter the template name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }

            if (selectedItems.length < 1){
                Toast.open({
                    message: "Please choose at least one item to add to the template",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }

            self.isLoading = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/template/update", {
                superEmail: localStorage.getItem("superEmail"),
                _id: self.templateData._id,
                name: name,
                selectedItems: selectedItems
            })
            .then(response => {
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }
                self.isLoading = false;
            })
            .catch(e => {
                console.log(e.response);
                if (e.response.status == 400) {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                } else {
                    Toast.open({
                        message:
                            "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading = false;
            });
        },
        getItems() {
            let self = this;
            self.listItem = []
            self.isLoading = true;

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/item/list", {
                    superEmail: localStorage.getItem("superEmail")
            })
            .then(response => {
                if (response.data.success == true) {
                    self.listItem = response.data.listItem
                    console.log("101 self.listItem")
                    console.log(self.listItem)
                } else {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading = false;
            })
            .catch(e => {
                console.log(e.response);
                if (e.response.status == 400) {
                    Toast.open({
                        message: e.response.data.msg,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                } else {
                    Toast.open({
                        message:
                            "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                        type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    });
                }
                self.isLoading = false;
            });
        },
        goHome() {
            this.$router.push({
                name: "SuperHome"
            });
        },
        goSuperItems() {
            this.$router.push({
                name: "SuperItems"
            });
        },
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
html,
body {
    font-size: 16px;
    line-height: 1.5;
    height: 100%;
    background: #ecf0f3;
}
nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
}
.navbar-item.brand-text {
    font-weight: 300;
}
.navbar-item,
.navbar-link {
    font-size: 14px;
    font-weight: 700;
}
.columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
}
.menu-label {
    color: #8f99a3;
    letter-spacing: 1.3;
    font-weight: 700;
}
.menu-list a {
    color: #0f1d38;
    font-size: 14px;
    font-weight: 700;
}
.menu-list a:hover {
    background-color: transparent;
    color: #276cda;
}
.menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
}
.card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
}
.card-header-title {
    color: #8f99a3;
    font-weight: 400;
}
.info-tiles {
    margin: 1rem 0;
}
.info-tiles .subtitle {
    font-weight: 300;
    color: #8f99a3;
}
.hero.welcome.is-info {
    background: #36d1dc;
    background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
    background: linear-gradient(to right, #5b86e5, #36d1dc);
}
.hero.welcome .title,
.hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
}
.card .content {
    font-size: 14px;
}
.card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8f99a3;
}
.card-table .table {
    margin-bottom: 0;
}
.events-card .card-table {
    max-height: 250px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Super/TemplateView.vue